import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import DocumentsPage from "@/pages/DocumentsPage";
import VendorsPage from "@/pages/VendorsPage";
import WorkOrdersPage from "@/pages/WorkOrdersPage";
import MachineryPage from "@/pages/MachineryPage";
import EmployeesPage from "@/pages/EmployeesPage";
import InvoicesPage from "@/pages/InvoicesPage";
import CompliancePage from "@/pages/CompliancePage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/documents" element={<DocumentsPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/work-orders" element={<WorkOrdersPage />} />
              <Route path="/machinery" element={<MachineryPage />} />
              <Route path="/employees" element={<EmployeesPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/compliance" element={<CompliancePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
